import type { RootState } from './store';
import { createStore } from './store';
import { window } from '../../../js/globals';

const state = window?.CHECKOUT_STATE || {} as RootState;

const store = createStore({ ...state });

export default store;
